<style lang="scss" scoped>
.upload-modal::v-deep .v--modal-box {
  border-radius: 5px;
  overflow: visible;
  display: inline-block;
  width: auto !important;
  transform: translateX(-50%);
  left: 50% !important;
  padding: 50px;
}
img {
  display: block;
  border-radius: 5px;
  max-height: calc(100vh - 20px);
  max-width: calc(100vw - 40px);
}
.upload-progress {
  display: flex;
  align-items: center;
  background-color: $teal;
  height: 10px;
}
.progress-box {
  display: flex;
  align-items: center;
  width: 250px;
  margin-top: 5px;
  border: solid 1px $gray-500;
  background-color: $gray-500;
  border-radius: 50px;
}
</style>

<template>
  <modal
    class="upload-modal"
    name="upload-modal"
    height="auto"
    width="350px"
    :adaptive="true"
  >
    <upload-status></upload-status>
  </modal>
</template>

<script>
import UploadStatus from "@/components/Customer/UploadStatus.vue";

export default {
  components: {
    UploadStatus
  }
};
</script>
